import { external_api } from 'app_config/globals'
import { moodleAuthChange, moodleAuthFormRequest } from 'app_events/auth/actions'
import { CombinedReducers } from 'app_events/index'
import React, { FC, useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const LoginMoodleByRequest: FC = () => {
  const form = useRef<HTMLFormElement>(null)
  const auth = useSelector((state: CombinedReducers) => state.auth)
  const moodleData = useMemo(() => auth?.user?.data?.moodle, [auth])
  const moodleAuthRequested = useSelector((store: CombinedReducers) => store.auth.moodleFormRequest)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!!form?.current && moodleAuthRequested === true) {
      form.current.submit()
      dispatch(moodleAuthChange(true))
      dispatch(moodleAuthFormRequest(false))
    }
  }, [moodleAuthRequested, dispatch])

  useEffect(() => {
    dispatch(moodleAuthChange(false))
  }, [dispatch])

  return (
    <form
      method="POST"
      target='_blank'
      action={`${external_api?.moodle?.url}/login/index.php`}
      ref={form}
    >
      <input type="hidden" name="username" value={`${moodleData?.username}`} />
      <input type="hidden" name="password" value={`${moodleData?.password}`} />
    </form>
  )
}

export default LoginMoodleByRequest
